import {crearHash} from "../Funciones/crearHash";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {registrarMovimiento} from "../Movimientos/registrarMovimiento";
import {adap_compra_mov} from "../Adaptadores/adap_compra_mov";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {adap_retiro_mov} from "../Adaptadores/adap_retiro_mov";

export const realizarRetiro = async ({usuario, desde, valor, metodo, billetera}) => {


    let doxConsecutivo = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})

    let retiro = {
        nombre: usuario.nombre,
        codigo: usuario.codigo,
        correo: usuario.correo,
        valor: valor * -1,
        fecha: new Date().getTime(),
        idUsuario: usuario.id,
        consecutivo: doxConsecutivo.data,
        detalle: "Retiro " + metodo + ' a espera de desembolso',

    }

    retiro.desde = desde
    retiro.hashString = JSON.stringify(retiro)
    retiro.hash = crearHash({text: retiro.hashString})


    let dox = await registrarMovimiento({
        movimiento: adap_retiro_mov({usuario: usuario, compra: retiro, metodo: metodo, billetera: billetera}),
        estado: 'Validando',
    })

    await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: retiro.consecutivo})

    return dox

}
